/*
============================================================
CHESSBURGER.TV — DATI LEZIONI EDU+
============================================================

QUESTO È IL FILE DA MODIFICARE QUANDO AGGIUNGI UNA LEZIONE.
La pagina, i conteggi e i filtri si aggiornano automaticamente.

STRUTTURA DI UNA LEZIONE
------------------------
{
  title: "TITOLO DEL VIDEO",
  video: "ID_YOUTUBE",

  // AREA DI STUDIO (una sola)
  // a = Aperture / 1.e4 Col Bianco
  // b = Aperture / 1.d4 Col Bianco
  // c = Aperture / Minori Col Bianco
  // d = Aperture / 1.e4 Col Nero
  // e = Aperture / 1.d4 Col Nero
  // f = Aperture / Minori Col Nero
  // g = Mediogioco / Base
  // h = Mediogioco / Intermedio
  // i = Mediogioco / Avanzato
  // l = Finali / Base
  // m = Finali / Intermedi
  // n = Partite / Alto Livello
  // o = Partite / Allievi / Livello Intermedio
  area: "a",

  // PERCORSI (zero, uno o più)
  // []    = nessun percorso
  // PV    = Partita Viennese
  // PC    = Partita del Centro
  // TR    = Trompowsky
  // PO    = Ponziani
  // RL    = Ruy Lopez
  // GF    = Gambetto Francese
  // GDR   = Gambetto di Donna Rifiutato
  //
  // Un video può appartenere anche a più percorsi:
  // paths: ["RL", "GF"]
  paths: ["RL"],

  // BIBLIOTECA
  // true  = lezione permanente: resterà disponibile sul canale
  // false = normale lezione EDU+: in futuro potrebbe essere rimossa da YouTube
  library: false
}

IMPORTANTE
----------
- area, paths e library sono INDIPENDENTI.
- Una lezione può quindi essere, per esempio:
    Aperture / 1.e4 Col Bianco
    + Percorso Ruy Lopez
    + Biblioteca
- "R" NON è più una categoria. Ruy Lopez è il percorso "RL".
- Per aggiungere una lezione nuova, inserisci un nuovo oggetto IN CIMA a lessons.
- L'ID YouTube è la parte dopo watch?v= nel link pubblico.
============================================================
*/
window.EDU_LIBRARY = {
  "taxonomy": {
    "a": {
      "category": "Aperture",
      "subcategory": "1.e4 Col Bianco"
    },
    "b": {
      "category": "Aperture",
      "subcategory": "1.d4 Col Bianco"
    },
    "c": {
      "category": "Aperture",
      "subcategory": "Minori Col Bianco"
    },
    "d": {
      "category": "Aperture",
      "subcategory": "1.e4 Col Nero"
    },
    "e": {
      "category": "Aperture",
      "subcategory": "1.d4 Col Nero"
    },
    "f": {
      "category": "Aperture",
      "subcategory": "Minori Col Nero"
    },
    "g": {
      "category": "Mediogioco",
      "subcategory": "Base"
    },
    "h": {
      "category": "Mediogioco",
      "subcategory": "Intermedio"
    },
    "i": {
      "category": "Mediogioco",
      "subcategory": "Avanzato"
    },
    "l": {
      "category": "Finali",
      "subcategory": "Base"
    },
    "m": {
      "category": "Finali",
      "subcategory": "Intermedi"
    },
    "n": {
      "category": "Partite",
      "subcategory": "Alto Livello"
    },
    "o": {
      "category": "Partite",
      "subcategory": "Allievi / Livello Intermedio"
    }
  },
  "paths": {
    "PV": {
      "name": "Partita Viennese",
      "color": "#F4D35E"
    },
    "PC": {
      "name": "Partita del Centro",
      "color": "#54D6C5"
    },
    "TR": {
      "name": "Trompowsky",
      "color": "#F28C28"
    },
    "PO": {
      "name": "Ponziani",
      "color": "#4F7CAC"
    },
    "RL": {
      "name": "Ruy Lopez",
      "color": "#F2C14E"
    },
    "GF": {
      "name": "Gambetto Francese",
      "color": "#B85C8A"
    },
    "GDR": {
      "name": "Gambetto di Donna Rifiutato",
      "color": "#A44A3F"
    }
  },
  "lessons": [
    {
      "title": "EST INDIANA MAKOGONOV IDEE GENERALI",
      "video": "M8etdV0RSrE",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "CONTROGAMBETTO TRAXLER PT.2",
      "video": "gf3rVnKkX7A",
      "area": "d",
      "paths": [],
      "library": false
    },
        {
      "title": "CONTROGAMBETTO TRAXLER PT.1",
      "video": "1cdFjZdrxLs",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "RUY LOPEZ IDEE RARE",
      "video": "hheIYnWc0B0",
      "area": "",
      "paths": ["RL"],
      "library": false
    },
    {
      "title": "FINALI DI TORRE - TEORIA LIVELLO INTERMEDIO",
      "video": "tOvtryoAzZ8",
      "area": "m",
      "paths": [],
      "library": false
    },
        {
      "title": "LOTTA PER UNA CASA E DINAMICA - MEDIOGIOCO",
      "video": "c8EQufzcwkU",
      "area": "o",
      "paths": [],
      "library": false
    },
        {
      "title": "RUY LOPEZ - VARIANTE APERTA PT.3",
      "video": "gU9ZWfK45tI",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
        {
      "title": "ITALIANA CON Cc3 PT.4",
      "video": "eBshNW2DTwY",
      "area": "a",
      "paths": [],
      "library": false
    },
        {
      "title": "RUY LOPEZ - ATTACCO WORRALL",
      "video": "nASiSWvclqs",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
        {
      "title": "ITALIANA CON Cc3 PT.3",
      "video": "LiolTJIiEEA",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "RUY LOPEZ - STRUTTURE & VARIANTE STEINITZ",
      "video": "QzPb-45bqYs",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "ITALIANA CON Cc3 PT.2",
      "video": "zK0-6NV6YXA",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "ITALIANA CON Cc3 PT.1",
      "video": "gx4C-x7-JgU",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "PROFILASSI PT.2",
      "video": "tgj3iBh_v5M",
      "area": "i",
      "paths": [],
      "library": false
    },
    {
      "title": "PROFILASSI PT.1",
      "video": "j9R91Zqsvpk",
      "area": "i",
      "paths": [],
      "library": false
    },
    {
      "title": "OPPOSIZIONE & FINALI BASE",
      "video": "LcTE_cRqWJo",
      "area": "l",
      "paths": [],
      "library": true
    },
    {
      "title": "GIOCARE CONTRO LA SCANDINAVA PRINCIPALE",
      "video": "aR_l9n3zNp0",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "CONSIGLI PRATICI, MEDIOGIO e FINALI DI PEDONI",
      "video": "bgaIsi76D_4",
      "area": "h",
      "paths": [],
      "library": true
    },
    {
      "title": "RUY LOPEZ PARTITA MODELLO (9...h6)",
      "video": "hdEND0yl67A",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "RUY LOPEZ - VARIANTE APERTA PT.2",
      "video": "dKaqxEk4TDc",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "FRANCESE CLASSICA CON Ag5: LIVELLO INTERMEDIO-AVANZATO",
      "video": "CXvCRHmsmjY",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "RUY LOPEZ - VARIANTE APERTA PT.1",
      "video": "trDl4alIIik",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "FRANCESE CLASSICA CON Ag5: INTRODUZIONE",
      "video": "5y0vJWXpu9w",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "FRANCESE CLASSICA: LA MIA PREPARAZIONE PER LA MASTER 2026",
      "video": "R8SW8sq5wXI",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "LINEA MODERNA NELL'ATTACCO CANAL",
      "video": "3MJZ2UdWQJQ",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "FRANCESE CLASSICA: LINEE PRINCIPALI",
      "video": "Nb4B2_tKf-8",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO FRANCESE: LINEE CON ...Cf5",
      "video": "PTLEwcOatEo",
      "area": "a",
      "paths": [
        "GF"
      ],
      "library": false
    },
    {
      "title": "IDEA CONTRO L'ATTACCO INDIANO",
      "video": "amN9u-FbTRc",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "GIOCA SEMPLICE CONTRO LA CARO-KANN: PT.2",
      "video": "reWpUxlC4Jc",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "GIOCA SEMPLICE CONTRO LA CARO-KANN: PT.1",
      "video": "VlsXI9bW5dg",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "RUY LOPEZ: VARINATE CHIGORIN PT.2",
      "video": "Kn7Pr5XROdE",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "RUY LOPEZ: VARINATE CHIGORIN PT.1",
      "video": "jeNZnxA6MPk",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "CATALANA: VARIANTE CHIUSA",
      "video": "FWAt9jkjlhc",
      "area": "b",
      "paths": [],
      "library": false
    },
    {
      "title": "RUY LOPEZ: VARIANTE BREYER PT.2",
      "video": "3PMoIgxe9R8",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "KALASHNIKOV: VARIANTE MINORE",
      "video": "TFkns4Qpj7U",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "RUY LOPEZ: VARIANTE BREYER PT.1",
      "video": "z5D8xN8y6Sw",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "RUY LOPEZ: VARIANTE ZAYTSEV PT.2",
      "video": "E2jyBahNago",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "RUY LOPEZ: VARIANTE ZAYTSEV PT.1",
      "video": "s7oGBHbEQcs",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "RUY LOPEZ: ANTI MARSHALL",
      "video": "sThReJJR9HA",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "RUY LOPEZ: GAMBETTO MARSHALL",
      "video": "InOI4FuMFHk",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "RUY LOPEZ: INTRODUZIONE",
      "video": "c9RFv-XngVE",
      "area": "",
      "paths": [
        "RL"
      ],
      "library": false
    },
    {
      "title": "CATALANA: VARIANTE APERTA",
      "video": "hHWa9uOaVPY",
      "area": "b",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTARE L'APERTURA LARSEN (1.b3)",
      "video": "cUAbLmvxbbE",
      "area": "f",
      "paths": [],
      "library": true
    },
    {
      "title": "TROMPOWSKY, ANALISI VAGANJAN",
      "video": "Re-orCz3fq4",
      "area": "b",
      "paths": [
        "TR"
      ],
      "library": true
    },
    {
      "title": "FRANCESE DI SPINTA: IDEE",
      "video": "Ksxj3vX0mjk",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA DI TORNEO SU GAMBETTO FRANCESE",
      "video": "kSDzKZr65z4",
      "area": "o",
      "paths": [
        "GF"
      ],
      "library": false
    },
    {
      "title": "COLLE CON Ae2",
      "video": "COcM46AMuP8",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "COLLE CON Ad3",
      "video": "9j4--oiU2RI",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "TROMPOWSKY, LINEE CON 2...C5",
      "video": "hB135QW68eM",
      "area": "b",
      "paths": [
        "TR"
      ],
      "library": true
    },
    {
      "title": "TROMPOWSKY - LINEE PRINCIPALI (CONT.)",
      "video": "tkm_p9k0goQ",
      "area": "b",
      "paths": [
        "TR"
      ],
      "library": true
    },
    {
      "title": "CARO-KANN - PEDONE DI DONNA ISOLATO",
      "video": "3l7IglBOzCU",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "TROMPOWSKY - LINEE PRINCIPALI",
      "video": "O8a0jqlYCMM",
      "area": "b",
      "paths": [
        "TR"
      ],
      "library": false
    },
    {
      "title": "ANALISI PARTITA: LOTTA PER UNA CASA",
      "video": "mr6Y3qpnPSU",
      "area": "i",
      "paths": [],
      "library": false
    },
    {
      "title": "TROMPOWSKY - IDEE CONTRO IL FIANCHETTO",
      "video": "0oAZQS-VQg8",
      "area": "b",
      "paths": [
        "TR"
      ],
      "library": true
    },
    {
      "title": "ALAPIN CON 5...Af5!?",
      "video": "k9OYtl9ylZM",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "PONZIANI - PARTITE DI ESEMPIO",
      "video": "RFir-QUFt2g",
      "area": "a",
      "paths": [
        "PO"
      ],
      "library": false
    },
    {
      "title": "TROMPOWSKY - INTRODUZIONE",
      "video": "4gRLm89un4I",
      "area": "b",
      "paths": [
        "TR"
      ],
      "library": true
    },
    {
      "title": "PONZIANI - VARIANTE PROFESSIONALE CON 4...f6",
      "video": "_inyD7isBo8",
      "area": "a",
      "paths": [
        "PO"
      ],
      "library": false
    },
    {
      "title": "ANALISI PARTITA EST INDIANA VARIANTE H3",
      "video": "_GKhjlO7TQ8",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "PONZIANI - VARIANTE PROFESSIONALE CON 4...Ad7",
      "video": "DkKOag-x7oo",
      "area": "a",
      "paths": [
        "PO"
      ],
      "library": false
    },
    {
      "title": "PHILIDOR PT.3 - VARIANTE DI CAMBIO",
      "video": "0LKjuAL-X4k",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "PONZIANI - VARIANTE TRAPPOLA",
      "video": "Y1D2LDCWlmk",
      "area": "a",
      "paths": [
        "PO"
      ],
      "library": false
    },
    {
      "title": "PHILIDOR PT.2 - GAMBETTO SHIROV ACCETTATO",
      "video": "r7bWxhEZ6L8",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "PHILIDOR PT.1 - GAMBETTO SHIROV RIFIUTATO",
      "video": "menNcDgX1fg",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "PONZIANI - VARIANTE CLASSICA",
      "video": "pJxGJOzUUlU",
      "area": "a",
      "paths": [
        "PO"
      ],
      "library": false
    },
    {
      "title": "PONZIANI - INTRODUZIONE",
      "video": "_JIaogGiGR0",
      "area": "a",
      "paths": [
        "PO"
      ],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA RUSSA PT.3 (VARIANTE DINAMICA)",
      "video": "w6n0M2odRwc",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "ANALISI PARTITA RUSSA",
      "video": "iFk38yXedOA",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA RUSSA PT.2 (AVANZATO)",
      "video": "6QbM9VAkY04",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "AFFRONTIAMO LA RUSSA PT.1 (PRINCIPIANTI)",
      "video": "O_mzgyAJYxk",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "GAMBETTO FRANCESE MODERNO - ANALISI PARTITA 1800",
      "video": "P7NhfkmN920",
      "area": "o",
      "paths": [
        "GF"
      ],
      "library": false
    },
    {
      "title": "TORRE E PEDONE vs TORRE: LE BASI",
      "video": "wlwzUsf0QLU",
      "area": "l",
      "paths": [],
      "library": true
    },
    {
      "title": "CONSIDERAZIONI PRATICHE: L'ABBANDONO",
      "video": "WYoSj1NBVHk",
      "area": "h",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO DI BUDAPEST (PANORAMICA)",
      "video": "zFVpcH1KD6U",
      "area": "b",
      "paths": [],
      "library": false
    },
    {
      "title": "TROMPOWSKY, ANALISI STEFANOVA-SHIROV",
      "video": "pmgccm0aSnU",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA CARLSBAD",
      "video": "CD-G9U3ubdY",
      "area": "b",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTARE LA TROMPOWSKY PT.1",
      "video": "JDBnxWEs2K4",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO FRANCESE - APPROCCIO MODERNO PT.1",
      "video": "RnLa06bf08c",
      "area": "a",
      "paths": [
        "GF"
      ],
      "library": false
    },
    {
      "title": "AFFRONTARE LA TROMPOWSKY PT.3",
      "video": "7i0Bt7xxX9U",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO FRANCESE - APPROCCIO MODERNO PT.3",
      "video": "KwJcGu_nneQ",
      "area": "a",
      "paths": [
        "GF"
      ],
      "library": false
    },
    {
      "title": "AFFRONTARE LA TROMPOWSKY PT.2",
      "video": "zdv5NKLd9ro",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO FRANCESE - APPROCCIO MODERNO PT.2",
      "video": "3rlxZzkFXQ0",
      "area": "a",
      "paths": [
        "GF"
      ],
      "library": false
    },
    {
      "title": "L'INCHIODATURA ...Ag4 NELLE STRUTTURE ITALIANE",
      "video": "cYWn7-ZC2Vk",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "GAMBETTO FRANCESE - LINEE CON dxc5",
      "video": "CARg0VPLgG8",
      "area": "a",
      "paths": [
        "GF"
      ],
      "library": false
    },
    {
      "title": "EST-INDIANA VARIANTE AVERBACK",
      "video": "WZ_sUh664CI",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "ANALISI PARTITA 1600 (MEDIOGIOCO-FINALE)",
      "video": "OprKmwHpCWs",
      "area": "o",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI EST-INDIANA H3 (MAKOGONOV)",
      "video": "dBeEZumGVRs",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "IDEE SULL'EST INDIANA (VARIANTE GLIGORIC)",
      "video": "KPM4Fk66Bgo",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "AFFRONTIAMO LA ROSSOLIMO - LINEA TRANQUILLA",
      "video": "oYBtX_wpHbI",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "SQUILIBRI DI MATERIALE",
      "video": "Ff-2_3g676g",
      "area": "i",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA ROSSOLIMO - LINEA DI GAMBETTO",
      "video": "bePqjewsFqU",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA ROSSOLIMO - LINEA AGGRESSIVA",
      "video": "b46p_RajcI0",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA 1900 (ALFIERE vs CAVALLO)",
      "video": "IEGngzuCp7M",
      "area": "o",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA ROSSOLIMO - VARIANTE PRINCIPALE",
      "video": "Xjs_wRHjq_o",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "FRANCESE VARIANTE WADE",
      "video": "FCZvyvUXm9g",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITE 1500-1700",
      "video": "ADZzb1qhLEk",
      "area": "o",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA ROSSOLIMO - VARIANTE DI CAMBIO, LINEE CONCRETE",
      "video": "hfbYNXXKegc",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA ROSSOLIMO - VARIANTE DI CAMBIO, LINEE TIPICHE",
      "video": "L70sQJbhkGo",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTIAMO LA ROSSOLIMO - INTRODUZIONE E LINEA CON D4 PRECOCE",
      "video": "L_-3cH2lqrc",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO VIENNESE - KARPOV",
      "video": "zNcSH3w58tQ",
      "area": "a",
      "paths": [
        "PV"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO VIENNESE - APPROCCIO \"MODERNO\" PT.2",
      "video": "aKEdO3hFDSs",
      "area": "a",
      "paths": [
        "PV"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO VIENNESE - APPROCCIO \"MODERNO\"",
      "video": "fyIM0PpDN6I",
      "area": "a",
      "paths": [
        "PV"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO VIENNESE - ANALISI PARTITA",
      "video": "usn9M21YCWw",
      "area": "a",
      "paths": [
        "PV"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO VIENNESE - LINEA TRAPPOLA",
      "video": "PngnXlxenEc",
      "area": "a",
      "paths": [
        "PV"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO VIENNESE - INTRODUZIONE",
      "video": "8RpFQpVjnRo",
      "area": "a",
      "paths": [
        "PV"
      ],
      "library": false
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: ANCORA 2...Cc6",
      "video": "IVYI-hI7aNk",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "ATTACCO INDIANO: ANALISI PARTITA DI FISCHER",
      "video": "9biLB-0Dqs0",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: 2...Cc6",
      "video": "oIC6AMSssQo",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "EST INDIANA 4 PEDONI PT.2",
      "video": "mEcZDhUeou8",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "EST INDIANA 4 PEDONI PT.1",
      "video": "DRvHMTB2iwE",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "ATTACCO INDIANO PT.1",
      "video": "CHu3Xc9fwY8",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI MILES - ATALIK",
      "video": "CIzIhiyzN0I",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI BROWNE - BYRNE (1977)",
      "video": "eCz1wO_E40A",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: ANALISI ALTRA PARTITA",
      "video": "E36AFR6M3qA",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "RIFLESSIONI SU MATERIALE E SICUREZZA DEL RE",
      "video": "uvDswY8XoK0",
      "area": "h",
      "paths": [],
      "library": false
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: ANALISI ULTERIORE PARTITA",
      "video": "NapPHCIO6Xw",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: VARIANTE ...AC5",
      "video": "I8oYA7jGJkU",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "VANTAGGIO DI SPAZIO",
      "video": "v0GNMSPsegg",
      "area": "h",
      "paths": [],
      "library": false
    },
    {
      "title": "CARO-KANN, PEDONE DI DONNA ISOLATO PT.2",
      "video": "3Sia4JtErEc",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "CARO-KANN, PEDONE DI DONNA ISOLATO PT.1",
      "video": "RyKoMk4iVwk",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: VARIANTE PRINCIPALE",
      "video": "vgOSFiP2O9Q",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "EST INDIANA FIANCHETTO: VARIANTE SIMMETRICA",
      "video": "-YRpcVi51ag",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: VARIANTE SOLIDA",
      "video": "o56iH9s2BQA",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "IDEE NUOVE NELLA PARTITA DEL CENTRO: INTRODUZIONE",
      "video": "z-jskBIdJI8",
      "area": "a",
      "paths": [
        "PC"
      ],
      "library": false
    },
    {
      "title": "EST INDIANA FIANCHETTO: VARIANTE JUGOSLAVA",
      "video": "I1ftTzuL5lA",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "SCANDINAVA - ANALISI PARTITA",
      "video": "L_8iD0DJISY",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "SCANDINAVA - AVANZATO",
      "video": "znVzOJg2Hl4",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "SCANDINAVA - INTERMEDIO",
      "video": "xrH1XL46UKQ",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "SCANDINAVA - PRINCIPIANTI",
      "video": "9X4Wshbn_1E",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "SICILIANA: AFFRONTARE IL GRAND PRIX",
      "video": "q7FfG8Oi314",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "RE ESPOSTO PT.1",
      "video": "16_EJAe5pp4",
      "area": "g",
      "paths": [],
      "library": true
    },
    {
      "title": "ANALISI PARTITA PIRC",
      "video": "LzVIW2bEhTA",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI INGLESE - SICILIANA CHIUSA",
      "video": "JqntjSG5nhQ",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "CAPABLANCA - SPAGNOLA",
      "video": "f9KCEWn5RJE",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "EST INDIANA - BENONI",
      "video": "CXz6roUJQFs",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO BENKO - 5.e3!?",
      "video": "x_13mvGFcN8",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO FRANCESE - ANALISI",
      "video": "0RCzPNWMxSw",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO BENKO - VARIANTE DI FIANCHETTO",
      "video": "YpTrU_HBXuw",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO BENKO - BAREEV-KASPAROV",
      "video": "PlZku2c9hQE",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO BENKO - INTRODUZIONE",
      "video": "nGtalf8WTGs",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA DI PETROSYAN",
      "video": "IAFYeOy1uUg",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "ANAND - KAMSKY (1995)",
      "video": "diZStb2VmLg",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO WING PT.2",
      "video": "b_T4Er3Xlu0",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO WING PT.1",
      "video": "6tq05SQeTEw",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA - SQUILIBRI",
      "video": "1o_WFXxWFeo",
      "area": "n",
      "paths": [],
      "library": true
    },
    {
      "title": "ANALISI PARTITA EST INDIANA",
      "video": "c7oSAwYGSkA",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "VARIANTE SAMISH PT.4",
      "video": "LGHAzFKXuOI",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "VARIANTE SAMISH PT.3",
      "video": "GZYUA4Fk1QE",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "ALAPIN CON 2...b6",
      "video": "XXi5hKgJR0M",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA D'ATTACCO",
      "video": "dqcm15XBlSs",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "PARTITA D'ESEMPIO SULLA STRUTTURA SVESHNIKOV",
      "video": "vb_HdMrs0Kg",
      "area": "g",
      "paths": [],
      "library": false
    },
    {
      "title": "CAPIAMO GLI SQUILIBRI PT.4",
      "video": "2LRbZZ0cYbA",
      "area": "g",
      "paths": [],
      "library": true
    },
    {
      "title": "INGLESE SIMMETRICA",
      "video": "xcDL7Q-kOb4",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "DIFESA ALEKHINE",
      "video": "HwKNTAudt8A",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "INGLESE - ANALISI PARTITA DRAGONE IN CONTROMOSSA",
      "video": "FFNuyI67TGw",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "CAPIAMO GLI SQUILIBRI PT.3",
      "video": "M_ppbtpHmtA",
      "area": "g",
      "paths": [],
      "library": true
    },
    {
      "title": "ANALISI KAMSKY - ADAMS",
      "video": "LZUPeEWJ5bA",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "INGLESE - VARIANTE KERES PT.2",
      "video": "wwWsGPL6tjc",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "INGLESE - VARIANTE KERES PT.1",
      "video": "ZNPBUntGqso",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA SUL PANOV (CARO KANN)",
      "video": "UUU1yGB_lF8",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "CAPIAMO GLI SQUILIBRI PT.2",
      "video": "lMy-ymJd1tc",
      "area": "g",
      "paths": [],
      "library": true
    },
    {
      "title": "INGLESE PT.4 - BENONI IN CONTROMOSSA",
      "video": "wAnqNviFFok",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI INGLESE - SICILIANA CHIUSA IN CONTROMOSSA",
      "video": "lhwhjyObtt8",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "INGLESE PT.3 - DRAGONE IN CONTROMOSSA",
      "video": "ZvTk6Ddio1E",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "CAPIAMO GLI SQUILIBRI PT.1 - APERTURA",
      "video": "FoKaQihVHKo",
      "area": "g",
      "paths": [],
      "library": true
    },
    {
      "title": "INGLESE PT.2 - VARIANTE KARPOV",
      "video": "02NvXbFTYSQ",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "INGLESE PT.1 - VARIANTE KARPOV",
      "video": "vSEZENGuo3A",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA D’ATTACCO",
      "video": "hl9lxruSSZg",
      "area": "n",
      "paths": [],
      "library": false
    },
    {
      "title": "ANALISI PARTITA EST INDIANA",
      "video": "Vp141gxmTgY",
      "area": "e",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTARE IL GAMBETTO ROUSSEAU",
      "video": "hLcFBB0koGQ",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "PEDONE DI DONNA ISOLATO",
      "video": "dNQB_F6GOzU",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "SLAVA DI CAMBIO PT.2",
      "video": "O3Ly2gfeR9o",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "SLAVA DI CAMBIO PT.1",
      "video": "RmfksYEs_FE",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "PARTITA D'ESEMPIO SUL GAMBETTO DI DONNA",
      "video": "Dk8hZih5pa4",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO DI DONNA PT.6",
      "video": "7zQesbLDP3w",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO DI DONNA PT.5",
      "video": "wIP1CD-ex44",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO DI DONNA PT.4",
      "video": "p03dQWYXWaE",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO DI DONNA PT.3",
      "video": "KzdfEQY6Q3o",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO DI DONNA (STRUTTURA CARLSBAD) PT.2",
      "video": "9vfr0uKbqNM",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "GAMBETTO DI DONNA (STRUTTURA CARLSBAD) PT.1",
      "video": "rOqVixrOWwk",
      "area": "b",
      "paths": [
        "GDR"
      ],
      "library": false
    },
    {
      "title": "ATTACCO CANAL PT.3",
      "video": "DuyK_i6_VIk",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "ATTACCO CANAL PT.2",
      "video": "CETJLc-hPls",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "ATTACCO CANAL PT.1",
      "video": "Lw7nMErPVac",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "ATTACCO INDIANO PT.2",
      "video": "iwlmJTCmb-o",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "ATTACCO INDIANO PT.1",
      "video": "rWNQtr-RZr0",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "FRANCESE PT.2",
      "video": "f6YhYKa2qwY",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "PARTITA DI ESEMPIO SULLA PIRC",
      "video": "4BPtT-LhBSs",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "GAMBETTO DI RE",
      "video": "S08Zl5zhmNM",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "BLACKMAR CONTRO LA SCANDINAVA",
      "video": "c4ESq3MhlF8",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "BLACKMAR CONTRO LA CARO KANN",
      "video": "5rlwfFGiQ98",
      "area": "c",
      "paths": [],
      "library": false
    },
    {
      "title": "KALASHNIKOV CON 6.C4",
      "video": "Md3qU5j61U4",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "AFFRONTARE L’INGLESE",
      "video": "KvNCDyoHYmQ",
      "area": "f",
      "paths": [],
      "library": true
    },
    {
      "title": "DIFESA OWEN & APERTURE IRREGOLARI",
      "video": "4VcTnsVbC9k",
      "area": "c",
      "paths": [],
      "library": true
    },
    {
      "title": "SICILIANA ALAPIN (DA NERO)",
      "video": "Bw5uzkUVyzE",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "EST INDIANA - VARIANTE DI FIANCHETTO",
      "video": "79TjF-PXKDI",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "KALASHNIKOV: VARIANTI PER LIVELLO INTERMEDIO",
      "video": "MUbl42719S0",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "AFFRONTARE LA ROSSOLIMO",
      "video": "WJeFzKAZlb8",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "SICILIANA KALASHNIKOV",
      "video": "qGX7kpjK4F8",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "SICILIANA CHIUSA",
      "video": "81olHYdpI7w",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "INTRODUZIONE ALLA SICILIANA: LINEE MINORI",
      "video": "6mvuPny6P5c",
      "area": "d",
      "paths": [],
      "library": true
    },
    {
      "title": "GAMBETTO CONTRO LA FRANCESE",
      "video": "ePrHny6Ob04",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTARE LA PIRC",
      "video": "TDc-naDJobY",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "IDEE SULLA GIUOCO PIANO",
      "video": "8vltLaJTCNw",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "VARIANTE SAMISCH PT.2",
      "video": "G6tWAdJJUx0",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "VARIANTE SAMISCH PT.1",
      "video": "avvL9M4HQTw",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "EST INDIANA - VARIANTI MINORI PT.2",
      "video": "kR3EDsllJbc",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "EST INDIANA - VARIANTI MINORI PT.1",
      "video": "RsI0D-UQ60w",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "ALAPIN CON 2…Cf6",
      "video": "EthZpMMLIU8",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "ALAPIN CON 2…d5",
      "video": "s_R1wwdPfXo",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "PEDONE \"D\" ISOLATO",
      "video": "Ts2jmXziWpw",
      "area": "h",
      "paths": [],
      "library": false
    },
    {
      "title": "SICILIANA ALAPIN - VARIANTI SECONDARIE E ERRORI TIPICI",
      "video": "F7NVjBVxOtU",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "EST INDIANA - VARIANTE PETROSIAN",
      "video": "X60gaXmuPhs",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "EST INDIANA - MAR DE PLATA PT.2",
      "video": "2el8FMi4mnQ",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "EST INDIANA - MAR DE PLATA PT.1",
      "video": "2el8FMi4mnQ",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "GAMBETTO MAX LANGE PT.2",
      "video": "AwMUEt8K2_E",
      "area": "a",
      "paths": [],
      "library": false
    },
    {
      "title": "DIFESA FRANCESE",
      "video": "uE4_wYTyp9I",
      "area": "d",
      "paths": [],
      "library": false
    },
    {
      "title": "AFFRONTARE IL SISTEMA DI LONDRA",
      "video": "mz5vVU7CTpA",
      "area": "e",
      "paths": [],
      "library": true
    },
    {
      "title": "FEGATELLO",
      "video": "QNmF0EAXkCU",
      "area": "a",
      "paths": [],
      "library": true
    },
    {
      "title": "GAMBETTO MAX LANGE",
      "video": "T5F5YEUUHck",
      "area": "a",
      "paths": [],
      "library": true
    }
  ]
};
